export function toggleFAQ(_el,force) {
    let toggled = force ?? 0;
    const _parent = _el.parentElement;
    if (typeof force === "undefined") {
      if(_el.dataset.toggled == "0") {
        toggled = 1;
        _parent.classList.add('rank-math-list-item--active');
      } else {
        toggled = 0;
        _parent.classList.remove('rank-math-list-item--active');
      }
   }
   const _answer = _el.nextElementSibling;
   if (!toggled) {
     _answer.style.height = "0px";
   } else {
     _answer.style.height = _answer.scrollHeight + 36 + "px"
   }
   _el.dataset.toggled = toggled;
  } 